import Box from "@ui-kit/layout/Box/Box.web";
import Button from "@ui-kit/form/Button/Button.web";
import Text from "@ui-kit/typography/Text/Text.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import useDatePickerQuickOptions from "./hooks/useDatePickerQuickOptions";
import { DatePickerQuickOptionsProps } from "./DatePickerQuickOptions.props";

export default function DatePickerQuickOptions({
  setSelection,
  mode,
  onChangeSelected,
  setMonth,
  customMenuOptions,
}: DatePickerQuickOptionsProps) {
  const dateQuickMenuOptions = useDatePickerQuickOptions({
    setSelection,
    mode,
    onChangeSelected,
    setMonth,
  });
  return (
    <Box
      data-testid="date-picker-modal-quick-menu"
      flexGrow={1}
      padding={{
        base: "var(--chakra-spacing-md) var(--chakra-spacing-none) var(--chakra-spacing-sm) var(--chakra-spacing-none)",
        md: "var(--chakra-spacing-xl) var(--chakra-spacing-xs) var(--chakra-spacing-none) var(--chakra-spacing-md)",
      }}
    >
      {customMenuOptions || (
        <Box>
          <Text
            as="h3"
            fontWeight="700"
            ml="md"
            display={{ base: "none", md: "block" }}
            paddingBottom="xl"
          >
            {new Date().getFullYear()}
          </Text>
          <Flex
            display="flex"
            flexWrap="wrap"
            flexDirection={{
              base: "row",
              md: "column",
            }}
            alignItems={{ base: "flex-start", md: "stretch" }}
            justifyContent={{ base: "space-around", md: "flex-start" }}
          >
            {dateQuickMenuOptions.map(({ title, onClick }) => {
              return (
                <Button.Nav
                  key={title}
                  onClick={onClick}
                  aria-label={title}
                  fontSize="sm"
                  mb="xs"
                  fontWeight="400"
                  justifyContent="flex-start"
                  data-testid={`date-picker-quick-menu-option-${title}`}
                >
                  {title}
                </Button.Nav>
              );
            })}
          </Flex>
        </Box>
      )}
    </Box>
  );
}
